<template>
  <v-snackbar
    v-if="status && snackbarData"
    v-model="status"
    right
    :color="snackbarData.status"
    :timeout="3000"
  >
    <span style="font-size: 16px; color: #ffffff">
      {{ snackbarData.message }}
    </span>
    <v-btn text @click="status = false">
      <v-icon color="#ffffff">mdi-close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: "Snackbar",
  props: {
    snackbar: {
      type: Boolean,
      default: false
    },
    snackbarData: {
      type: Object
    }
  },
  data: () => ({
    status: false
  }),
  watch: {
    snackbar() {
      this.status = this.snackbar;
    },
    status() {
      this.$emit("input", this.status);
    }
  }
};
</script>

<style scoped></style>
